import React, { useState } from 'react';
import styled from 'styled-components';
import CCPopover from 'components/shared/DesignSystem/SlabTransferPortal/Floating/CCPopover';
import AssignedUsers from 'components/shared/AssignUsers/AssignedUsers';
import UserSelect from 'components/shared/AssignUsers/UserSelect';
import { AssignedUserObject } from 'data/v3/data-contracts';

// #region styled-components
const ContentContainer = styled.div`
  padding: var(--cc_size_spacing_m);
  width: 320px;
`;
// #endregion styled-components

type AssignUserPopoverProps = {
  assignableUsers: AssignedUserObject[];
  assignedUsers: AssignedUserObject[];
  trigger: React.ReactNode;
  onAssignUser: (user: AssignedUserObject) => void;
  onRemoveUser: (id: AssignedUserObject['id']) => void;
  hasGetAssignableUsersError: boolean;
};

const AssignUserPopover = ({
  assignedUsers,
  assignableUsers,
  trigger,
  onAssignUser,
  onRemoveUser,
  hasGetAssignableUsersError,
}: AssignUserPopoverProps) => {
  const [isAssignedUserPopoverOpen, setAssignedUserPopoverOpen] =
    useState(false);

  const handleToggle = () => {
    setAssignedUserPopoverOpen((prevIsOpen) => !prevIsOpen);
  };

  return (
    <CCPopover
      placement="bottom"
      isOpen={isAssignedUserPopoverOpen}
      onOpenChange={handleToggle}
      trigger={trigger}
      style={{ zIndex: 9999 }}
    >
      <ContentContainer>
        <UserSelect
          assignedUserIds={new Set(assignedUsers.map((user) => user.id))}
          assignableUsers={assignableUsers}
          onAssignUser={onAssignUser}
          hasGetAssignableUsersError={hasGetAssignableUsersError}
        />
        <AssignedUsers
          assignedUsers={assignedUsers}
          onRemoveUser={onRemoveUser}
        />
      </ContentContainer>
    </CCPopover>
  );
};

export default AssignUserPopover;
